import { createStore } from 'vuex';
import EventsModule from './events';

export default createStore({
  modules: {
    events: EventsModule
  }
});